// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_fU","advertDetailParameterList__header":"c-q_fV","advertDetailParameterList__list":"c-q_fW"};